import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#0d0d0d] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-14">

          {/* Column 1: Company */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-medium mb-5 flex items-center justify-center md:justify-start gap-2 text-base">
              • Company
            </h3>
            <ul className="space-y-3 text-[15px] text-gray-400">
              <li><Link to="/company" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/releasenote" className="hover:text-white transition-colors">Release Notes</Link></li>
              <li><Link to="/warrantypolicy" className="hover:text-white transition-colors">Warranty Policy</Link></li>
              <li><Link to="/privacypolicy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Column 2: Products */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-medium mb-5 flex items-center justify-center md:justify-start gap-2 text-base">
              • Products
            </h3>
            <ul className="space-y-3 text-[15px] text-gray-400">
              <li><Link to="/product" className="hover:text-white transition-colors">All Products</Link></li>
              <li><Link to="/user-interface" className="hover:text-white transition-colors">User Interface</Link></li>
              <li><Link to="/cloud" className="hover:text-white transition-colors">RMC Cloud</Link></li>
              <li><Link to="/mobile-link" className="hover:text-white transition-colors">Mobile Management</Link></li>
              <li><Link to="/video-integration" className="hover:text-white transition-colors">Video Integration</Link></li>
            </ul>
          </div>

          {/* Column 3: Support */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-medium mb-5 flex items-center justify-center md:justify-start gap-2 text-base">
              • Support
            </h3>
            <ul className="space-y-3 text-[15px] text-gray-400">
              <li><Link to="/documentation-library" className="hover:text-white transition-colors">Documentation</Link></li>
              <li><Link to="/mobile-applications" className="hover:text-white transition-colors">Mobile Apps</Link></li>
              <li><Link to="/feedback" className="hover:text-white transition-colors">Feedback</Link></li>
              <li><Link to="/contact-us" className="hover:text-white transition-colors">Contact Us</Link></li>
              <li>
                <a
                  href="https://beorak.cafe24.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Neptune 1.0 Legacy
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Get in touch */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-medium mb-5 flex items-center justify-center md:justify-start gap-2 text-base">
              • Get in touch
            </h3>
            <div className="space-y-4 text-[15px] text-gray-400">

              {/* Address */}
              <div className="flex gap-3 justify-center md:justify-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="mt-0.5 shrink-0">
                  <path d="M20 10C20 14.993 14.461 20.193 12.601 21.799C12.4277 21.9293 12.2168 21.9998 12 21.9998C11.7832 21.9998 11.5723 21.9293 11.399 21.799C9.539 20.193 4 14.993 4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10Z" stroke="#2F6BFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#2F6BFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div>
                  <p className="text-white font-medium">Massachusetts, USA</p>
                  <p className="leading-tight">129A Morgan Drive, Norwood MA 02082</p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex gap-3 justify-center md:justify-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M13.832 16.568C14.0385 16.6628 14.2712 16.6845 14.4917 16.6294C14.7122 16.5744 14.9073 16.4458 15.045 16.265L15.4 15.8C15.5863 15.5516 15.8279 15.35 16.1056 15.2111C16.3833 15.0723 16.6895 15 17 15H20C20.5304 15 21.0391 15.2107 21.4142 15.5858C21.7893 15.9609 22 16.4696 22 17V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22C15.2261 22 10.6477 20.1036 7.27208 16.7279C3.89642 13.3523 2 8.7739 2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H7C7.53043 2 8.03914 2.21071 8.41421 2.58579C8.78929 2.96086 9 3.46957 9 4V7C9 7.31049 8.92771 7.61672 8.78885 7.89443C8.65 8.17214 8.44839 8.41371 8.2 8.6L7.732 8.951C7.54842 9.09118 7.41902 9.29059 7.36579 9.51535C7.31256 9.74012 7.33878 9.97638 7.44 10.184C8.80668 12.9599 11.0544 15.2048 13.832 16.568Z" stroke="#2F6BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div>
                  <p className="text-white font-medium">Phone</p>
                  <a href="tel:8573460130" className="hover:text-white transition-colors">
                    857-346-0130
                  </a>
                </div>
              </div>

              {/* Business Hours */}
              <div className="flex gap-3 justify-center md:justify-start">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#2F6BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div>
                  <p className="text-white font-medium">Business Hours</p>
                  <p>Mon-Fri: 8AM – 7PM EST</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-8 py-4 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <p>© 2026 Sicunet Inc. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <Link to="/privacypolicy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <span className="text-gray-700">•</span>
            <Link to="/warrantypolicy" className="hover:text-white transition-colors">Warranty Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;